<router-outlet></router-outlet>

<!-- Spinner -->
<ngx-spinner bdOpacity=0.9 bdColor="rgb(182 174 174 / 20%)" size="medium" color="rgb(19 86 100)" type="ball-spin-clockwise-fade"
    [fullScreen]="true">Loading...
</ngx-spinner>
